export const STUDENT_DATA_REQUEST = 'STUDENT_DATA_REQUEST'
export const STUDENT_DATA_SUCCESS = 'STUDENT_DATA_SUCCESS'
export const STUDENT_DATA_FAILURE = 'STUDENT_DATA_FAILURE'

